import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogShellComponent } from '../../blog-shell/blog-shell.component';
import { TranslationSyncService } from '../../../../services/translation-sync.service';
import { BlogEntryBase } from '../../shared/blog-entry-base';

@Component({
  selector: 'app-cube-portfolio',
  standalone: true,
  imports: [BlogShellComponent, CommonModule],
  templateUrl: './cube-portfolio.component.html',
  styleUrls: ['./cube-portfolio.component.css']
})
export class CubePortfolioComponent extends BlogEntryBase {
  constructor(sync: TranslationSyncService) {
    super(sync);
  }
}
